import React, {useEffect} from 'react';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import StorageSettingsUI from '../view/StorageSettingsUI';
import NavigationStore from '../../../../navigation/store/NavigationStore';
import DashboardStore from '../../store/DashboardStore';
import {ORGANIZATION_SUBSCRIPTION_ACTIVE} from '../../../../data/models/Oganization/Organization';

interface Props {
  dashboardStore?: DashboardStore;
  navigationStore?: NavigationStore;
}

const StorageSettingsContainer = inject(
  'dashboardStore',
  'navigationStore',
)(
  observer(({dashboardStore, navigationStore}: Props) => {
    const {organizationId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      if (
        organizationId &&
        navigationStore!.subscriptionStatus === ORGANIZATION_SUBSCRIPTION_ACTIVE
      ) {
        dashboardStore!.fetchDashboardDetails(organizationId);
      }
    }, []);

    const plan = navigationStore!.organizationSubscription?.type;

    return (
      <StorageSettingsUI
        dashboard={dashboardStore!.dashboardData}
        onBuyAddons={() => navigate(`/${organizationId}/marketplace`)}
        disabled={plan === 0 || plan === undefined}
      />
    );
  }),
);

export default StorageSettingsContainer;
